/**
 * 向下查找组件
 * @author weishengjian
 * @date 2018/11/19
 */
export function findComponentsDownward(context, componentName) {
    return context.$children.reduce((components, child) => {
        switch (LinkUtils.typeOf(componentName)) {
            case 'string':
                if (child.$options.name === componentName) components.push(child);
                break;
            case 'function':
                if (componentName(child)) components.push(child)
                break
            default :
                console.error('invalid param:', componentName)
        }
        const foundChilds = findComponentsDownward(child, componentName);
        return components.concat(foundChilds);
    }, []);
}

/**
 * 向上查找组件
 * @author weishengjian
 * @date 2018/11/19
 */
export function findComponentsUpward(context, componentName) {
    let parents = [];
    const parent = context.$parent;
    if (parent) {
        if (parent.$options.name === componentName) parents.push(parent);
        return parents.concat(findComponentsUpward(parent, componentName));
    } else {
        return [];
    }
}

/**
 * 向上查找一个组件
 * @author weishengjian
 * @date 2018/11/19
 */
export function findComponentUpward(context, componentName, componentNames) {
    if (typeof componentName === 'string') {
        componentNames = [componentName];
    } else {
        componentNames = componentName;
    }

    let parent = context.$parent;
    if (!parent) return null

    let name = parent.$options.name;
    while (parent && (!name || componentNames.indexOf(name) < 0)) {
        parent = parent.$parent;
        if (parent) name = parent.$options.name;
    }
    return parent;
}


/**
 * 将光标移动到末尾
 * @author weishengjian
 * @date 2018/11/19
 */
export function moveCursorToEnd(obj) {
    if (window.getSelection) {//ie11 10 9 ff safari
        obj.focus(); //解决ff不获取焦点无法定位问题
        let range = window.getSelection();//创建range
        range.selectAllChildren(obj);//range 选择obj下所有子内容
        range.collapseToEnd();//光标移至最后
    } else if (document.selection) {//ie10 9 8 7 6 5
        let range = document.selection.createRange();//创建选择对象
        //let range = document.body.createTextRange();
        range.moveToElementText(obj);//range定位到obj
        range.collapse(false);//光标移至最后
        range.select();
    }
}

/*----------------------------------------------------------------------------------*/

/**
 * 监听粘贴事件
 * @author weishengjian
 * @date 2018/11/19
 */
export function onPasteImage(obj, handler) {
    obj.addEventListener('paste', function (event) {
        // 添加到事件对象中的访问系统剪贴板的接口
        let clipboardData = event.clipboardData;
        let i = 0, items, item, types;

        if (clipboardData) {
            items = clipboardData.items;
            if (!items) return;
            item = items[0];
            // 保存在剪贴板中的数据类型
            types = clipboardData.types || [];
            for (; i < types.length; i++) {
                if (types[i] === 'Files') {
                    item = items[i];
                    break;
                }
            }
            // 判断是否为图片数据
            if (item && item.kind === 'file' && item.type.match(/^image\//i)) {
                // 读取该图片
                imgReader(item, handler);
            }
        }
    });
}

/*----------------------------------------------------------------------------------*/

/**
 * 读取图片
 * @author weishengjian
 * @date 2018/11/19
 */
function imgReader(target, handler) {
    let file = target.getAsFile(),
        reader = new FileReader();
    reader.onload = function (e) {
        handler(e.target.result)
    };
    reader.readAsDataURL(file);
}

/*----------------------------------------------------------------------------------*/

/**
 * 是否包含某种样式class
 * @author 韦胜健
 * @date 2018/11/19
 */
function hasClass(el, cls) {
    if (!!el.classList && !!el.classList.value) return LinkUtils.oneOf(cls, el.classList.value.split(' '));
    else return (el.className || '').split(' ').indexOf(cls) > -1
}

/**
 * 添加class
 * @author 韦胜健
 * @date 2018/11/19
 */
export function addClass(el, addCLs) {
    if (!el || !addCLs) return;
    const addClasses = LinkUtils.typeOf(addCLs) === 'string' ? addCLs.split(' ') : addCLs
    if (!!el.classList && !!el.classList.value) {
        addClasses.forEach(item => el.classList.add(item))
    } else {
        const curClasses = (el.className || '').split(' ')
        addClasses.forEach(item => {
            if (curClasses.indexOf(item) === -1) curClasses.push(item)
        })
        el.className = curClasses.join(' ')
    }
}

/**
 * 删除class
 * @author 韦胜健
 * @date 2018/11/19
 */
export function removeClass(el, rmCls) {
    if (!el || !rmCls) return;
    const rmClasses = LinkUtils.typeOf(rmCls) === 'string' ? rmCls.split(' ') : rmCls
    if (!!el.classList && !!el.classList.value) {
        rmClasses.forEach(item => el.classList.remove(item))
    } else {
        const curClasses = (el.className || '').split(' ')
        for (let i = 0; i < rmClasses.length; i++) {
            const rmClass = rmClasses[i];
            const index = curClasses.indexOf(rmClass)
            if (index > -1) {
                curClasses.splice(index, 1)
                i--
            }
        }
        el.className = curClasses.join(' ')
    }
}

/*----------------------------------------------------------------------------------*/
/**
 * 检测浏览器使用的是哪一种前缀
 * @author weishengjian
 * @date 2018/11/19
 */
let elementStyle = document.createElement('div').style;

function caculateVender() {
    let transformNames = {
        wehkit: 'wehkitTransform',
        Moz: 'MozTransform',
        O: 'OTransform',
        ms: 'msTransform',
        standard: 'transform'
    };
    for (let key in transformNames) {
        if (elementStyle[transformNames[key]] !== undefined) {
            return key;
        }
    }
    return false;
}

let vender = caculateVender();

/**
 * 获取浏览器css兼容性前缀
 * @author weishengjian
 * @date 2018/11/19
 */
export function prefixStyle(style) {
    if (vender === false) {
        return false;
    }
    if (vender === 'standard') {
        return style;
    }
    return vender + style.charAt(0).toUpperCase() + style.substr(1);
}


/**
 * 获取style
 * @author weishengjian
 * @date 2018/11/19
 */
export function getStyle(element, styleName) {
    if (!element || !styleName) return null;
    styleName = camelCase(styleName);
    if (styleName === 'float') {
        styleName = 'cssFloat';
    }
    try {
        const computed = document.defaultView.getComputedStyle(element, '');
        return element.style[styleName] || computed ? computed[styleName] : null;
    } catch (e) {
        return element.style[styleName];
    }
}

/**
 * 在元素节点后面添加新的节点
 * @author weishengjian
 * @date 2018/11/19
 */
export function insertAfter(newEl, targetEl) {
    let parentEl = targetEl.parentNode;
    if (parentEl.lastChild === targetEl) {
        // 如果最后的节点是目标元素，则直接添加。因为默认是最后
        parentEl.appendChild(newEl);
    } else {
        //如果不是，则插入在目标元素的下一个兄弟节点 的前面。也就是目标元素的后面
        parentEl.insertBefore(newEl, targetEl.nextSibling);
    }
}

/*
 *  禁用全局选择文字功能
 *  @author     martsforever
 *  @datetime   2018/12/28 20:56
 */
function enableSelectNone() {
    addClass(window.document.body, 'link-body-user-select-none')
}

/*
 *  启用全局选择文字功能
 *  @author     martsforever
 *  @datetime   2018/12/28 20:56
 */
function disabledSelectNone() {
    removeClass(window.document.body, 'link-body-user-select-none')
}

/**
 * 绑定事件操作，兼容ie
 * @type {Function}
 */
export const on = (function () {
	if (document.addEventListener) {
		return function (element, event, handler) {
			if (element && event && handler) {
				element.addEventListener(event, handler, false);
			}
		};
	}
	return function (element, event, handler) {
		if (element && event && handler) {
			element.attachEvent(`on${event}`, handler);
		}
	};
}());

/**
 * 移除绑定事件操作
 * @type {Function}
 */
export const off = (function () {
	if (document.removeEventListener) {
		return function (element, event, handler) {
			if (element && event) {
				element.removeEventListener(event, handler, false);
			}
		};
	}
	return function (element, event, handler) {
		if (element && event) {
			element.detachEvent(`on${event}`, handler);
		}
	};
}());

export default {
    findComponentsDownward,
    findComponentsUpward,
    findComponentUpward,
    hasClass,
    addClass,
    removeClass,
    insertAfter,
    enableSelectNone,
    disabledSelectNone,
	on,
	off
}
